import { useTranslation } from 'react-i18next';
import ReactDOMServer from 'react-dom/server';
import { Table } from 'react-bootstrap';

// Component
import ButtonAction from 'components/ButtonAction';
import Checkbox from 'components/Checkbox';
import TooltipDialogFixed from 'components/TooltipDialogFixed';

const SyslogServerTable = (props) => {
  const {
    tableRef,
    stickyStyle,
    tableHeader,
    selectedPage,
    selectedPageLimit,
    currentSyslogServerList,
    modalStatus,
    changeModalStatus,
    checkedAllState,
    toggleCheckedAll,
    toggleChecked,
    selectSyslogServerCallback,
    handleDelete
  } = props;

  const { t } = useTranslation();

  // Method
  const siteTooltipContent = (siteList) => {
    return (
      <Table hover>
        <thead>
          <tr>
            <th>#</th>
            <th>Site</th>
          </tr>
        </thead>
        <tbody>
          {siteList.map((item, index) => (
            <tr key={item.id}>
              <td>{index + 1}</td>
              <td>{item.site}</td>
            </tr>
          ))}
        </tbody>
      </Table>
    );
  };

  return (
    <Table responsive striped hover className="table-container" ref={tableRef}>
      <thead style={stickyStyle}>
        <tr>
          <th>
            <Checkbox
              id="syslog-server-th-cb1"
              type='checkbox'
              checked={checkedAllState()}
              onChange={toggleCheckedAll}
            />
          </th>
          <th>#</th>
          {tableHeader()}
          <th>
            {t('06df33001c')}
          </th>
        </tr>
      </thead>
      <tbody>
        {currentSyslogServerList && currentSyslogServerList.map((syslogServer, index) => {
          return (
            <tr key={index}>
              <td>
                <Checkbox
                  id={`rl-cb-smal-${index}`}
                  type='checkbox'
                  disabled={syslogServer.siteList.length > 0}
                  checked={syslogServer.checked === true}
                  onChange={() => toggleChecked(index)}
                />
              </td>
              <td>{((selectedPage - 1) * selectedPageLimit) + index + 1}</td>
              <td>{syslogServer.name}</td>
              <td>{syslogServer.server}</td>
              <td>{syslogServer.port}</td>
              <td>{syslogServer.protocol}</td>
              <td>
                {syslogServer.siteList.length === 0 && (<div className='ms-1 me-1'>0</div>)}
                {syslogServer.siteList.length > 0 && (
                  <TooltipDialogFixed
                    className="ms-1 me-1"
                    placement="right"
                    title={ReactDOMServer.renderToString(siteTooltipContent(syslogServer.siteList))}
                    hideIcon={true}
                    tooltipsTitle={syslogServer.siteList.length}
                  />
                )}
              </td>
              <td className={'table-action-td'}>
                <ButtonAction
                  label="7e77616685"
                  title="7e77616685"
                  iconClassName="icon-edit"
                  onClick={() => {
                    selectSyslogServerCallback(syslogServer);
                    changeModalStatus(modalStatus.addOrEdit.type, true)
                  }}
                />
                <ButtonAction
                  label="ce64bbe3ba"
                  title="ce64bbe3ba"
                  iconClassName="icon-trash"
                  disabled={syslogServer.siteList.length > 0}
                  onClick={() => {
                    handleDelete(syslogServer.id);
                    changeModalStatus(modalStatus.delete.type, true);
                  }}
                />
              </td>
            </tr>
          );
        })}
      </tbody>
    </Table>
  );
};

export default SyslogServerTable;
